/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from "react";
import type { Settings } from "~/types/settings";
export const defaultSettings: Settings = {
  colorPreset: "served",
  contrast: "normal",
  direction: "ltr",
  layout: "vertical",
  navColor: "evident",
  paletteMode: "light",
  responsiveFontSizes: true,
  stretch: false
};
export interface State extends Settings {
  isSettingDrawerOpen: boolean;
  isNavDrawerOpen: boolean;
  isInitialized: boolean;
}
export const initialState: State = {
  ...defaultSettings,
  isInitialized: false,
  isSettingDrawerOpen: false,
  isNavDrawerOpen: false
};
export interface SettingsContextType extends State {
  handleCloseNavDrawer: () => void;
  handleOpenNavDrawer: () => void;
  handleCloseSettingDrawer: () => void;
  handleOpenSettingDrawer: () => void;
  handleReset: () => void;
  handleUpdate: (settings: Settings) => void;
  isCustom: boolean;
}
export const SettingsContext = createContext<SettingsContextType>({
  ...initialState,
  handleCloseNavDrawer: () => {},
  handleOpenNavDrawer: () => {},
  handleCloseSettingDrawer: () => {},
  handleOpenSettingDrawer: () => {},
  handleReset: () => {},
  handleUpdate: () => {},
  isCustom: false
});